(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .component('cronogramaFungicidasAplicacao', {
      templateUrl: 'views/cronograma_fungicidas/aplicacao.html',
      controller: 'CronogramaFungicidasAplicacaoCtrl',
      bindings: {
        cronograma: '<',
        aplicacao: '<',
        onUpdate: '&',
        onUpdateSchedule: '&',
        cancelNewAplicacao: '&'
      }
    });
}());
